import { makeConnectState } from 'web-app/util/redux/make-connect-state';
/**
 * @deprecated Use the `useTypedSelector` hook instead.
 */
export const connectState = makeConnectState();
